import request from '@/utils/request'

// 查询列表
export function apiMesFlowPathHeadList (query) {
  return request({
    url: '/mes/mesFlowPathHead/list',
    method: 'get',
    params: query
  })
}
// 详情
export function apiMesFlowPathLineOrderApprovalList (query) {
  return request({
    url: "/mes/mesFlowPathLine/orderApprovalList",
    method: 'get',
    params: query
  })
}

// 审批
export function apiKernelFlowExternalBpm (url, data) {
  return request({
    url: url,
    method: 'post',
    data: data
  })
}

// 基础信息
export function apiMesFlowOrderApprovalHeader (query) {
  return request({
    url: "/mes/mesFlowPathHead/orderApprovalHeader",
    method: 'get',
    params: query
  })
}

// 详情-盘点调整单审批
export function apiMesFlowPathLineWmsApprovalList (query) {
  return request({
    url: "/mes/mesFlowPathLine/wmsApprovalList",
    method: 'get',
    params: query
  })
}

// 流程终止
export function apiMesTerminateProcess (data) {
  return request({
    url: `/mes/mesDiscreteJobs/terminateProcess`,
    method: 'post',
    data: data
  })
}

// 查询流程行字段定义列表
export function apiMesFlowPathParamDefineList (query) {
  return request({
    url: "/mes/mesFlowPathParamDefine/list",
    method: 'get',
    params: query
  })
}

// 查询流程工单行列表方法二
export function apiMesGetMesFlowPathLinesList (query) {
  return request({
    url: "/mes/mesFlowPathLine/getMesFlowPathLinesList",
    method: 'get',
    params: query
  })
}

// 更新审批流程表字段信息
export function apiUpdateMesFlowPathLines (data) {
  return request({
    url: `/mes/mesFlowPathLine/updateMesFlowPathLines`,
    method: 'post',
    data: data
  })
}
